import { useState } from "react";
import HelpWindow from "../HelpWindow/HelpWindow";

const Seed = ({ style, dictionary, changeSettings, isLoading }) => {
	const [value, setValue] = useState(0);

	const changeValue = ({ target }) => {
		setValue(target.value);
		changeSettings(target.value, "seed");
	};

	return (
		<div className={style["settings-default-item"]}>
			<p className={style[`title`]}>
				{dictionary["seed"] || "Seed"}
				<HelpWindow dictionary={dictionary} name={"seed"} />
			</p>
			<input id="seed-input" disabled={isLoading} type="number" value={value} onChange={changeValue} />
		</div>
	);
};

export default Seed;
